














































































import Vue from "vue";
import store from "@/store";
import draggable from "vuedraggable";

// *** Interfaces
import {
  SetTemplate,
  ExerciseTemplate,
  WorkoutTemplateSubmit,
} from "@/interfaces/workoutTemplate.interface";
import { getNowInUnix } from "@/interfaces/time.interface";
import { dialogOptions } from "@/interfaces/dialog.interface";
import { userWorkoutTemplate } from "@/interfaces/user.interface";
import { Exercise, ExerciseEmitData } from "@/interfaces/exercise.interface";

// Components
import ExerciseTemplateCard from "@/components/ExerciseTemplateCard.vue";
import AddNewExerciseDialog from "@/components/dialogs/AddNewExerciseDialog.vue";

export default Vue.extend({
  props: {
    templateId: String,
    newTemplate: {
      type: Boolean,
      default: false,
    },
    workoutTemplateDialog: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      // Workout Data
      workoutName: "Workout",
      workoutNote: "",

      // Exercise Data
      exercises: [] as Exercise[],

      workoutTemplateData: Object() as userWorkoutTemplate,

      addNewExerciseDialog: false,

      overlayLoader: false,
    };
  },
  created() {
    //  Todo: make this into a function in interface
    this.workoutTemplateData = {
      workoutName: "Workout Template",
      lastDone: null,
      timesDone: 0,
      templateOrderIdx: store.getters["templateStore/getUserTemplates"].length,
      exercises: [],
      dateCreated: getNowInUnix(),
      id: "",
      datesDone: [],
    };

    if (this.templateId) {
      let allWorkoutTemplates: userWorkoutTemplate[] =
        store.getters["templateStore/getUserTemplates"];

      allWorkoutTemplates.forEach((template) => {
        if (template.id === this.templateId) {
          this.workoutTemplateData = template;
        }
      });
    }
    this.resetTemplateData();
  },
  methods: {
    resetTemplateData() {
      this.workoutName = "";
      this.workoutNote = "";
      this.exercises = [];

      if (this.templateId) {
        this.workoutName = this.workoutTemplateData.workoutName;

        // Set Workout Note
        if (
          this.workoutTemplateData.workoutNote &&
          this.workoutTemplateData.workoutNote !== ""
        )
          this.workoutNote = this.workoutTemplateData.workoutNote;
        else this.workoutNote = "";

        // Exercises
        this.workoutTemplateData.exercises.forEach(
          (exercise: ExerciseTemplate) => {
            let setListWithReactiveData: any = [];

            exercise.sets.forEach((set: SetTemplate) => {
              let setReactiveData = Object.assign({}, set);
              setReactiveData.done = false;
              setReactiveData.wantVideo = false;
              if (!setReactiveData.setNoteWanted)
                setReactiveData.setNoteWanted = false;

              setListWithReactiveData.push(setReactiveData);
            });

            let formattedExercise: Exercise = {
              exerciseName: exercise.exerciseName,
              bodyParts: exercise.bodyParts,
              type: exercise.type,
              sets: setListWithReactiveData,
              showExercise: true,
              wantExerciseNote: false,
            };

            this.exercises.push(formattedExercise);
          }
        );
      }
    },
    dialogController(dialog: dialogOptions) {
      this.$emit("dialogController", dialog);
    },
    localDialogController(dialogToBeOpen: dialogOptions) {
      this.addNewExerciseDialog = false;
      if (dialogToBeOpen === "addNewExerciseDialog")
        this.addNewExerciseDialog = true;
    },
    addExercises(newExercises: Exercise[]) {
      newExercises.forEach((newExercise) => {
        this.exercises.push(newExercise);
      });
      this.localDialogController("workoutTemplateDialog");
    },
    async submitWorkoutTemplate() {
      let templateDataSubmit: userWorkoutTemplate = this.workoutTemplateData;
      templateDataSubmit.exercises = this.exercises;

      // Check if there are any exercises
      let atLeastOneExercise = true;
      if (templateDataSubmit.exercises.length === 0) {
        atLeastOneExercise = false;
        alert("Add Exercises");
      }

      // Check if any sets in exercises are empty
      let anyExercisesEmpty = false;
      templateDataSubmit.exercises.forEach((exercise) => {
        if (exercise.sets.length === 0) {
          alert(
            `Exercise ${exercise.exerciseName} has 0 sets. Add sets or remove exercise`
          );
          anyExercisesEmpty = true;
        }
      });

      // Start Submitting Template
      if (!anyExercisesEmpty && atLeastOneExercise) {
        this.overlayLoader = true;
        // Delete all the helper fields for cosmetics
        templateDataSubmit.exercises.forEach((exercise) => {
          delete exercise.wantExerciseNote;
          delete exercise.showExercise;

          exercise.sets.forEach((set) => {
            delete set.setNoteWanted;
            delete set.setDurationWanted;
            delete set.wantVideo;
            delete set.done;
          });
        });

        // Create new template
        if (this.newTemplate) {
          const workoutTemplateSubmit: WorkoutTemplateSubmit = {
            workoutTemplateData: templateDataSubmit,
          };
          await store
            .dispatch(
              "templateStore/createWorkoutTemplate",
              workoutTemplateSubmit
            )
            .then(() => {
              this.dialogController("closeAll");
            })
            .catch(() => {
              alert("There was a problem uploading your template");
            });
        }
        // Update Template
        else {
          await store
            .dispatch("templateStore/updateWorkoutTemplate", templateDataSubmit)
            .then(() => {
              this.dialogController("closeAll");
            })
            .catch(() => {
              alert("There was a problem updating your template");
            });
        }
        this.overlayLoader = false;
      }
    },
    cancelWorkoutTemplate() {
      this.dialogController("closeAll");
    },
    // Exercise Cards Methods
    removeExercise(exerciseIdx: number) {
      this.exercises.splice(exerciseIdx, 1);
    },
    removeSet(exerciseEmitData: ExerciseEmitData) {
      this.exercises[exerciseEmitData.exerciseIdx].sets.splice(
        exerciseEmitData.setIdx,
        1
      );
    },
    addSetToExercise(data: any) {
      let exercise = this.exercises[data.exerciseIdx];
      exercise.sets.push(data.newSet);
      this.exercises[data.exerciseIdx].sets = exercise.sets;
    },
  },
  components: {
    draggable,
    AddNewExerciseDialog,
    ExerciseTemplateCard,
  },
});
